var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"py-2 text-xl",attrs:{"id":_vm.id},on:{"click":_vm.close}},[(_vm.isHr)?_c('hr',{staticClass:"w-full"}):_vm._e(),(_vm.route)?_c('router-link',{staticClass:"pl-3",attrs:{"to":_vm.route}},[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }